import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["ratingButtons", "ratingInput", "submitButton"]
  static values = {
    chatId: Number,
    cycle: Number
  }

  connect() {
    this.selectedRating = null
  }

  selectRating(event) {
    event.preventDefault()
    const button = event.currentTarget
    const rating = parseInt(button.dataset.rating)

    this.selectedRating = rating
    this.ratingInputTarget.value = rating

    // Update button styles
    const allButtons = this.ratingButtonsTarget.querySelectorAll('button')
    allButtons.forEach(btn => {
      const btnRating = parseInt(btn.dataset.rating)
      if (btnRating === rating) {
        btn.classList.remove('border-gray-300', 'text-gray-600')
        btn.classList.add('border-blue-500', 'bg-blue-500', 'text-white')
      } else {
        btn.classList.remove('border-blue-500', 'bg-blue-500', 'text-white')
        btn.classList.add('border-gray-300', 'text-gray-600')
      }
    })

    // Enable submit button
    this.submitButtonTarget.disabled = false
  }

  async submit(event) {
    event.preventDefault()

    if (!this.selectedRating) {
      return
    }

    const form = event.target
    const formData = new FormData(form)

    const issues = formData.getAll('ai_behavior_feedback[issues][]')
    const comment = formData.get('ai_behavior_feedback[comment]')

    try {
      const response = await fetch(`/chats/${this.chatIdValue}/ai_behavior_feedbacks`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        },
        body: JSON.stringify({
          cycle: this.cycleValue,
          ai_behavior_feedback: {
            rating: this.selectedRating,
            issues: issues,
            comment: comment
          }
        })
      })

      if (!response.ok) {
        const data = await response.json()
        console.error('Failed to submit feedback:', data.errors)
      }
    } catch (error) {
      console.error('Failed to submit feedback:', error)
    }
  }

  async dismiss(event) {
    event.preventDefault()

    try {
      await fetch(`/chats/${this.chatIdValue}/ai_behavior_feedbacks/dismiss`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        },
        body: JSON.stringify({
          cycle: this.cycleValue
        })
      })
    } catch (error) {
      console.error('Failed to dismiss feedback:', error)
    }
  }
}
